/* eslint-disable @nx/enforce-module-boundaries */

import { Box, HStack, Stack, VStack } from '@mybridge/ui';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { DiskBinModal } from 'v4/components/disk/bin-modal';
import { DiskContext, useDiskContext } from 'v4/components/disk/context';
import { SiteShortcutLinks } from 'v4/snippets/dashboard/site-shortcut-links';
import { DiskCopyModal } from 'v4/components/disk/copy-modal';
import { DiskCopyMultipleFilesModal } from 'v4/components/disk/copy-multi-modal';
import { MyDiskCreateFolderModal } from 'v4/components/disk/create-folder-modal';
import { DiskDeleteFileModal } from 'v4/components/disk/delete-modal';
import { DiskDownloadFileModal } from 'v4/components/disk/download-modal';
import { DiskDeleteMultipleFilesModal } from 'v4/components/disk/delete-multi-modal';
import { MyDiskListingProgress } from 'v4/components/disk/listing-progress';
import { DiskMoveModal } from 'v4/components/disk/move-modal';
import { DiskMoveMultipleFilesModal } from 'v4/components/disk/move-multi-modal';
import { DiskRenameFileModal } from 'v4/components/disk/rename-modal';
import { DiskShareFileModal } from 'v4/components/disk/share-modal';
import { FileUploadModal } from 'v4/components/disk/upload-modal';
import { getAllConnectionsData } from 'v4/store/actions/connection.actions';
import { BottomPanel } from './bottom-panel';
import { MyDiskLeftPanel } from './left-panel';
import { MyDiskRightPanel } from './right-panel';
import { RevokeSharedDiskModal } from 'v4/components/disk/shared-disk/revoke-shared-disk-modal';
import { isMobile } from 'react-device-detect';
import { DashboardMyCircle } from '../dashboard/circle';
import { TeamDiskBottomPanel } from '../teams/disk/bottom-panel';
import { TeamsLayout } from '../teams/layout/listing';
import { TeamsContext } from '../teams/context';
import { useContext } from 'react';
import { TeamDiskChangeDiskSubscriberModal } from '../teams/disk/team-disk-change-subscriber-modal';
import { TeamDiskAcceptChangeDiskSubscriberModal } from '../teams/disk/team-disk-accept-change-subscriber-modal';
import { Spacer } from '@chakra-ui/react';

export const MyDisk = () => {
  const dispatch = useDispatch();
  const myDisk = useDiskContext();
  
  const {
    createFolderDisc,
    uploadDisc,
    shareDisc,
    deleteDisc,
    downloadDisc,
    renameDisc,
    moveDisc,
    copyDisc,
    binDisc,
    multiDeleteDisc,
    multiCopyDisc,
    multiMoveDisc,
    revokeSharedDiskUserDisc,
    mobileFilePanelDisc,
  } = myDisk ?? {};
  const {
    changeDiskSubscriberDisc,
    diskSubscriptionChangeRequestDisc,
    userProfileInfo,
    teamDetails,
    diskSubscriptionChangeRequests
  } = useContext(TeamsContext);
  // useEffect(() => {
  //   dispatch(getAllConnectionsData());
  // }, []);

  useEffect(() => {
    if (diskSubscriptionChangeRequests?.length > 0 && userProfileInfo?.id !== teamDetails?.disk_payer_details?.id) {
      diskSubscriptionChangeRequestDisc?.onOpen?.();
    }
  }, [diskSubscriptionChangeRequests]);

  return (
    <DiskContext.Provider value={myDisk}>
      {isMobile ? (
        <VStack
          width={isMobile ? "100%" : "108%"}
          height="100%"
          backgroundColor="white"
          alignItems="stretch"
          justifyContent="space-between"
        >
          <VStack
            width="100%"
            alignItems="stretch"
            overflow="auto"
            height="100%"
          >
            <MyDiskListingProgress />
            {mobileFilePanelDisc?.isOpen ? (
              <MyDiskRightPanel />
            ) : (
              <MyDiskLeftPanel />
            )}
          </VStack>
          <BottomPanel />
        </VStack>
      ) : (
        <VStack minH={!isMobile && "120vh"} width="100%" height="100%" alignItems="stretch" pos='fixed' top={"70px"} overflow={"hidden"} justifyContent="space-between" gap={0}>
          {/* <Box>
            <MyDiskListingProgress /> */}
            <HStack minH={!isMobile && "100vh"} alignItems="stretch" spacing={0}>
            <HStack pos="sticky" top="0px" height="300px" alignItems="stretch" spacing={0}>
              <Stack
                display={['none', 'none', 'flex']}
                pos="sticky"
                top="64px"
                spacing={2}
                minH="100vh"
                // borderBottom="1px solid #e0e0e094"
                height={'500px'}
                zIndex="999"
              >
                <VStack
                  spacing={2}
                  justifyContent="space-between"
                  height="100%"
                  align="stretch"
                  h="calc(100vh - 0px)"
                  backgroundColor="rgb(255, 255, 255)"
                >
                  <VStack border='none' spacing={2} align="stretch" h="100%" flex="1" w="min-content">
                    <SiteShortcutLinks />
                    <Box
                    //  className={styles.hideTitle}
                    >
                      <DashboardMyCircle h="300px" flex="1" display={['none', 'none', 'none', 'flex']}/>
                    </Box>
                  </VStack>
                </VStack>
              </Stack>
            </HStack>
              <Box pos="sticky" top="0px" height="300px"> {/* Fixed width for Left Panel */}
                <MyDiskLeftPanel />
              </Box>
              <Box flex="1"> {/* Right Panel takes remaining space */}
                <MyDiskRightPanel />
              </Box>  
            </HStack>
          {/* </Box> */}
          {/* Align BottomPanel with MyDiskLeftPanel */}
          <HStack pos={!isMobile &&"fixed"} bottom={!isMobile &&"0px"} width={["100%", "100%", "100%", "80%"]} spacing={0}>
            <Spacer flex="0 0 21%" bg={"transparent"} display={['none', 'none', 'none', 'block']}/>{/* Spacer for alignment */}
            <Box w={["100%", "100%", "100%", "79%"]}>
              <BottomPanel />
          {/* <TeamDiskBottomPanel /> */}

            </Box>
          </HStack>
        </VStack>
      )}

      {createFolderDisc?.isOpen && <MyDiskCreateFolderModal />}
      {uploadDisc?.isOpen && <FileUploadModal />}
      {shareDisc?.isOpen && <DiskShareFileModal />}
      {deleteDisc?.isOpen && <DiskDeleteFileModal />}
      {downloadDisc?.isOpen && <DiskDownloadFileModal />} 
      {renameDisc?.isOpen && <DiskRenameFileModal />}
      {moveDisc?.isOpen && <DiskMoveModal />}
      {copyDisc?.isOpen && <DiskCopyModal />}
      {binDisc?.isOpen && <DiskBinModal />}
      {multiDeleteDisc?.isOpen && <DiskDeleteMultipleFilesModal />}
      {multiCopyDisc?.isOpen && <DiskCopyMultipleFilesModal />}
      {multiMoveDisc?.isOpen && <DiskMoveMultipleFilesModal />}
      {revokeSharedDiskUserDisc?.isOpen && <RevokeSharedDiskModal />}
      {changeDiskSubscriberDisc?.isOpen ? (
       <TeamDiskChangeDiskSubscriberModal />
      ) : (
        ''
      )}
      {diskSubscriptionChangeRequestDisc?.isOpen ? (
        <TeamDiskAcceptChangeDiskSubscriberModal />
      ) : (
        ''
      )}
    </DiskContext.Provider>
  
  );
};